import React from 'react';
import Service from "./components/service";
import '../../assets/css/pages/services/style.scss';
import DataLoader from "../../components/loader/dataLoader";
import useServices from "../../hooks/public/useServices";

const Index = () => {
    const {data,isLoading} = useServices();
    return (
        <section className="services">
            <div className='custom-container'>
                <div className='content-section'>
                    <h1 className='page-title'>Services</h1>
                    <div className='content-body'>
                        <div className="row mx-0">
                            <div className='col-12'>
                                {isLoading && <DataLoader/>}
                            </div>
                            {data && data.map(service =>
                                <div key={service.id} className="col-xl-3 col-lg-4 col-md-6">
                                    <Service service={service}/>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Index;
